import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { MODULE_API } from "../../../apis";
import { SelectionSkeleton } from "../../Skeletons/SelectionSkeleton";
export const SelectGoal = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [allGoals, setAllGoals] = useState([]);

  const restrictedGoalsForFreeTrial = [
    "Add Child",
    "Education",
    "Investment Property",
    "Start a Business",
  ];
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const isFreeTrial = [
    "FreeTrail",
    "Financial Advisor Client",
    "financial adviser client",
    "Active Financial Advisor",
    "Active financial adviser client",
    "Financial Advisor",
  ].includes(userRole);
  const getAllGoalsList = async () => {
    try {
      setLoading(true);
      let data = await MODULE_API.insuraceAllocation("Goals");
      if (data && data.goals) {
        const sortedGoals = data.goals.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setAllGoals(sortedGoals);
        // setAllGoals(data.goals)
      }
      setLoading(false);
    } catch (error) {
      console.log("e ", error);
      setLoading(false);
    }
  };
  function handleGoalSelect(title) {
    history.push(`/goals_add/attributes/${title}`);
  }
  useEffect(() => {
    getAllGoalsList();
  }, []);
  return (
    <div>
      <h2
        className="text-center font-weight-bold mb-4"
        style={{ fontFamily: "Poppins", marginTop: "1rem" }}
      >
        Select A Goal To Create
      </h2>
      <div className="selelctmain">
        <h3 className="selectHeading">Goals</h3>
        <div className="selectmain" style={{ justifyContent: "flex-start" }}>
          {allGoals &&
            allGoals.map((item, index) => {
              const isRestricted =
                isFreeTrial && restrictedGoalsForFreeTrial.includes(item.name);
              return (
                <div
                  key={index}
                  onClick={() => {
                    handleGoalSelect(item.name);
                  }}
                  className={`selectMaincards ${
                    isRestricted ? "disabled-goal" : ""
                  }`}
                >
                  <div className="selectMaincardsInner">
                    {" "}
                    <div className="selectMainImages">
                      <img src={item.image} height={"40px"} alt={item.name} />{" "}
                    </div>
                    <div className="selectMainHeader">
                      <span className="selectheadingValue">{item.name}</span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {loading && <SelectionSkeleton />}
    </div>
  );
};
